// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2oned","row":"ProcedureTreatmentSummary_row__1Jra2"};